import { useState } from 'react'
import './App.css'

import CallToAction from './components/CallToAction'
import Header from './components/Header'
import Features from './components/Features'
import Footer from './components/Footer'
import Download from './components/Download'

function App() {
  const [count, setCount] = useState(0)

  return (
    <>
      <Header/>
      <CallToAction/>
      <Features/>
      <Download/>
      <Footer/>
    </>
  )
}

export default App